export default {
  title: 'Novo Usuário',
  save: 'Salvar',
  create: 'Criar',
  firstName: 'Nome',
  lastName: 'Sobrenome',
  email: 'E-mail',
  repeatEmail: 'Repetir e-mail',
  setPasswordManually: 'Definir senha manualmente (não será enviado e-mail ao usuário)',
  password: 'Senha',
  repeatPassword: 'Repetir senha',
  phoneNumber: 'Número de telefone (se presente exigirá 2FA)',
  domain: 'Domínio',
  true: 'Verdadeiro',
  false: 'Falso',
  firstNameRequired: 'O nome é obrigatório',
  lastNameRequired: 'O sobrenome é obrigatório',
  emailRequired: 'O e-mail é obrigatório',
  emailInvalid: 'O e-mail deve ser válido',
  emailExists: 'O e-mail já existe',
  emailsMustMatch: 'Os e-mails devem coincidir',
  passwordRequirements: 'A senha deve ter mais de 12 caracteres e deve conter caracteres numéricos, minúsculos, maiúsculos e caracteres especiais (#, ?, !, @, $, %, ^, *, -)',
  passwordsMustMatch: 'As senhas devem coincidir',
  phoneNumberInvalid: 'O número de telefone deve começar com o código do país +X'
}
